
<inline-group>
  <input-wrapper class="wrapper-size">
      <span title>Startår</span>
      <woo-dropdown
        name="startWeekYear"
        [(ngModel)]="weeks.startWeekYear"
        (ngModelChange)="modelChanged('startWeekYear')"
        [items]="years"
        [disabled]="disabled"
      ></woo-dropdown>
  </input-wrapper>

    <input-wrapper class="wrapper-size">
    <span title for="startWeek">Startvecka</span>
    <input id="startWeek" name="startWeekNumber" type="number" format="number" class="input__item"
      [(ngModel)]="weeks.startWeekNumber" label min="1" max="{{weeksInSpecifikYear(weeks.startWeekYear)}}"
      (ngModelChange)="modelChanged('startWeekNumber')"
      (focusout)="modelChanged('startWeekNumber')"
      [disabled]="disabled" required>
    </input-wrapper>

    <input-wrapper class="wrapper-size">
      <span title>Slutår</span>
      <woo-dropdown
        name="endWeekYear"
        [(ngModel)]="weeks.endWeekYear"
        (ngModelChange)="modelChanged('endWeekYear')"
        [items]="years"
        [disabled]="disabled"
      ></woo-dropdown>
  </input-wrapper>

    <input-wrapper class="wrapper-size">
      <span title for="endWeek">Slutvecka</span>
      <input id="endWeek" name="endWeekNumber" type="number" format="number" class="input__item"
        [(ngModel)]="weeks.endWeekNumber" min="1" max="{{weeksInSpecifikYear(weeks.endWeekYear)}}"
        (ngModelChange)="modelChanged('endWeekNumber')"
        (focusout)="modelChanged('endWeekNumber')"
        [disabled]="disabled" required>
  </input-wrapper>

</inline-group>


